<div class="contents">
  <div class="spinner"></div>
  <div class="progress">{{ progressText }}</div>
</div>
